module.exports = __webpack_public_path__ + "static/img/hypnose-04.bc88db2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hypnose-04.png
// module id = 98
// module chunks = 0